module.exports = __webpack_public_path__ + "static/media/D4_C3_001.eeaa60e8.png";